<script setup lang="ts">
const route = useRoute()
const year = Number(route.params.year)

if (!Number.isInteger(year) || year < 1) {
  throw createError({ status: 404, message: '归档参数无效' })
}
</script>

<template>
  <BlogArchiveList :year="year" />
</template>
